import Component from './Component';
import {FFUtils} from "../utils/ff/FFUtils";

export default class FacetStorageComponent extends Component {
    get SELECTORS() {
        return {
            main: '.container',
            facetsDom: '.facets',
        }
    }

    get DATA() {
        return {
            magazine: 'data-magazine',
        }
    }

    get STORAGE() {
        return {
            facet: 'facet',
            scrollY: 'scrollY',
            facetMap: 'facetMap'
        }
    }

    constructor() {
        super();
        this.newSearchOptions = FFUtils.OPTIONS;
    }

    escapeFacet(str) {
        let first = String(str.split(':').shift()), //parametro di ricerca
            last = str.substring(str.indexOf(':')); //filtri selezionati

        first = first
            .replace(/%/g, '%25')
            .replace(/&#x25;/g, '%25')
            .replace(/ /g, '%20')
            .replace(/&#x20;/g, '%20')
            .replace(/&amp;/g, '%26')
            .replace(/&/g, '%26');

        return first.concat(last);
    }

    escapeFilterLast(key) {
        let first = String(key.query.value.split(':').shift()),
            last = key.query.value.substring(key.query.value.indexOf(':')).replace(/%/g, '%25');

        return key.query.value = first.concat(last);
    }

    setUrlDataBack() {
        if (!window.location.href.includes('databack=true')) {
            if (window.location.href.indexOf('?') < 0) {
                window.history.pushState('', '', window.location.href + '?databack=true');
            } else {
                window.history.pushState('', '', window.location.href + '&databack=true');
            }
        }
    }

    set(param, currentquery, currentqueryafter, query) {
        var queryFacet = '';
        if ((localStorage.getItem(this.STORAGE.facet) != undefined && localStorage.getItem(this.STORAGE.facet) != '') || query != null) {
            queryFacet = query != null ? query : JSON.parse(localStorage.getItem(this.STORAGE.facet)).query;
        }

        let facet = {
            'ctn': document.querySelector(this.SELECTORS.main).innerHTML,
            'query': queryFacet,
            'param': param,
            'currentquery': currentquery,
            'currentqueryafter': currentqueryafter
        }
        localStorage.setItem(this.STORAGE.facet, JSON.stringify(facet));
        localStorage.setItem(this.STORAGE.scrollY, window.pageYOffset);
        this.setUrlDataBack();
    }

    reset() {
        localStorage.setItem(this.STORAGE.facet, '');
    }

    render() {
        const magazine = document.querySelector(this.SELECTORS.facetsDom).getAttribute(this.DATA.magazine) === 'true';
        if (!magazine && this.newSearchOptions.newSearchOn === 'true') {
            return;
        }
        this.log('render Facet Storage');
    }
}
